import { render, staticRenderFns } from "./CandidateTimeLine.vue?vue&type=template&id=10244c72&scoped=true"
import script from "./CandidateTimeLine.vue?vue&type=script&lang=js"
export * from "./CandidateTimeLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10244c72",
  null
  
)

export default component.exports